import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { USER_MGMT_CNST } from '../../../../constants/proj.cnst';
import { isNullOrUndefined } from '../../../../modules/shared';
import { AppStateService } from '../../../../services/app-state.service';
import { EnvService } from '../../../../services/env.service';
import { HttpService } from '../../../../services/http.service';
import { UtilsService } from '../../../../services/utils.service';

import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { CustomerService } from '../../customer.service';
import { CommonModule } from '@angular/common';
import { PrimengTableComponent } from '../../../../modules/shared/components/primeng-table/primeng-table.component';
import { PrimengBreadcrumbComponent } from '../../../../modules/shared/components/primeng-breadcrumb/primeng-breadcrumb.component';
import { ImportsModule } from '../../../../modules/imports/imports';
import { SkeletonModule } from '../../../../modules/shared/components/skeleton/skeleton.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared/shared.module';
import { SearchFilterPipe } from '../../../../pipes/search-filter.pipe';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TablerIconComponent } from 'angular-tabler-icons';

@Component({
  selector: 'app-assign-resources',
  templateUrl: './assign-resources.component.html',
  imports : [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    SkeletonModule,
    ImportsModule,  
    SearchFilterPipe,
    IconFieldModule,
    InputIconModule,
    TablerIconComponent
  ]
})
export class AssignResourcesComponent implements OnInit, OnDestroy {

  @Input() applicationId: any;
  @Input() disabled: boolean = false;
  @Output() getData = new EventEmitter<any>();
  loading!: boolean;
  @Output() loadingResourceList = new EventEmitter<any>();
  
  appDetails: any;

  resourcesData: any = null;
  resourceTypeMap = USER_MGMT_CNST.RESOURCE_TYPES_MAP;
  actionNameMapping : any = USER_MGMT_CNST.ACTION_NAME_MAPPING;

  searchApi!: string;
  searchWidget!:string;
  searchDashboard!:string;
  searchUrl!:string;

  resourceTypes: string[] = [];
  customerDetails: any;
  @Input() customerId: any;

  subscriptions : Subscription[] = [];
  @Input() applicationName: any;
  @Input() applicationListWithResources: any;
  resourcesIDs: any = {}
  
  constructor(
    private appState: AppStateService,
    private httpSrv: HttpService,
    private utilSrv: UtilsService,
    private envService: EnvService,
    private router: Router,
    private messageService: MessageService,
    private custService : CustomerService
  ) { }

  async ngOnInit() {
    this.loading = true;
    this.customerDetails = this.appState.getCustomerData();
    this.appDetails = this.appState.getSelectedResourceDetails();

    if (!this.utilSrv.isObjectNotNullAndEmpty(this.appDetails)) {
      
      let appsListWithResources = this.applicationListWithResources;

      if (this.utilSrv.isObjectNotNullAndEmpty(appsListWithResources)) {
        let { response } = appsListWithResources;

        if (this.utilSrv.isObjectNotNullAndEmpty(response)) {

          let appInfo = Object.keys(response)
            .filter((appName: string) => this.applicationName === appName);

          if (appInfo.length > 0) {
            let appDetails = response[appInfo[0]];

            if (this.utilSrv.isObjectNotNullAndEmpty(appDetails)) {

              let modifiedAppDetails = {
                key : this.applicationName,
                value : appDetails
              }

              this.appDetails = modifiedAppDetails;
            }
          }
        }
      }
    }
    this.fetchData();
  }


  selectAll(type: string,searchTerm:string) {
    const filteredResources = this.resourcesData[type].filter((res: any) => 
      res.resourceName.toLowerCase()?.includes(searchTerm?.toLowerCase() ?? '')
  );

    for (let resource of filteredResources) {
        resource['isAssigned'] = true; }
    this.checkBoxCommon(type, -1);
  } 

  clearAll(type: string,searchTerm:string) {
    const filteredResources = this.resourcesData[type].filter((res: any) => 
      res.resourceName?.toLowerCase().includes(searchTerm?.toLowerCase() ?? '')
  );

    for(let resource of filteredResources) {
      resource['isAssigned'] = false;
    }
    this.checkBoxCommon(type, -1);
  }

  checkBoxCommon(resourceType: string, resource:any) {
    this.subscribeData()
    let resources = this.getformatResourceData();
    if(resource !== -1){
        let item =  this.resourcesData[resourceType]?.find((res: any) => res.resourceActionId == resource.resourceActionId);
        item.isAssigned = !item.isAssigned;
        this.removeEditAlsoIfReadRemoved(resourceType,resource);
    }

    let previousSelectedResources = resources.previouslySelectedResource
    let selectedResourceIds = this.resourcesIDs?.['resourceActionIdsToAdd'] ? this.resourcesIDs?.['resourceActionIdsToAdd']  : [];
    let deletedResourceIds = this.resourcesIDs?.['resourceActionIdsToDelete'] ? this.resourcesIDs?.['resourceActionIdsToDelete']  : [];
    let resourceActionIdsTrue = this.extractResourceActionIds(this.resourcesData[resourceType], true);
    let resourceActionIdsFalse = this.extractResourceActionIds(this.resourcesData[resourceType], false);


    resourceActionIdsTrue = resourceActionIdsTrue.filter((item: any) => !previousSelectedResources.includes(item))
    selectedResourceIds = selectedResourceIds.filter((item: any) => !resourceActionIdsFalse.includes(item))
    deletedResourceIds = deletedResourceIds.filter((item: any) => !resourceActionIdsTrue.includes(item))
    
    const updatedSeleted = [...new Set([...selectedResourceIds, ...resourceActionIdsTrue])];
    const updatedDeleted = [...new Set([...deletedResourceIds, ...resourceActionIdsFalse])];

    this.custService.setResourcesIDs({
      'resourceActionIdsToAdd': updatedSeleted,
      'resourceActionIdsToDelete': updatedDeleted
    })

    let customerId = !isNullOrUndefined(this.customerId)? this.customerId: this.appState.getCurrentCustomerId();
 
    let postData: {
      "customerId": any,
      "assignResources": any[],
      "deleteResources": any[],
      "customerDetailsJson": any
    } = {
      "customerId": null,
      "assignResources": [],
      "deleteResources": [],
      "customerDetailsJson": "{}"
    }
    
    if (!isNullOrUndefined(customerId)) {
    
      postData.customerId = customerId;
      
      
      postData.assignResources = this.getAssignedResource(resources.selectedResources, resources.previouslySelectedResource);
      postData.deleteResources = this.getDeletedResource(resources.selectedResources, resources.previouslySelectedResource);
      this.getData.emit(postData);
    }
  }


  extractResourceActionIds(data : any, isAssigned : boolean) {
    const resourceActionIds: any[] = [];
    data?.forEach((dashboard: { isAssigned: boolean; resourceActionId: any; }) => {
      if (dashboard.isAssigned === isAssigned) {
        resourceActionIds.push(dashboard.resourceActionId);
      }
    });
  
    return resourceActionIds;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  fetchData() {   
    if (!isNullOrUndefined(this.applicationId)) {
      this.httpSrv.makeGetApiCall('FETCH_RESOURCES_BY_APPLICATION_ID', this.envService.baseUrl, { uriParams: { applicationId: this.applicationId } }).subscribe({
        next: (response: any) => {
          this.subscribeData()
          this.resourcesData = this.formatResponse(response['response']);  
        },
        complete: ()=> {
          this.loading = false;
          this.loadingResourceList.emit(this.loading);
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to fetch applications list"})
          this.loading = false;
          this.loadingResourceList.emit(this.loading);          
        }
      });     
    } else {
      console.log("Application id is null or undefined ", this.applicationId);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: "Unable to fetch resources for application"})
    }
  }

  subscribeData(){
    let resourcesIDsSubscription = this.custService.resourcesIDsIndex$.subscribe(
      (data: any) => {
        this.resourcesIDs = data;
      }
    );
    this.subscriptions.push(resourcesIDsSubscription)
  }

  formatResponse(data: any) {
    let resourceTypeDataMap: {
      "APIs": any[],
      "URLs": any[],
      "Dashboards": any[],
      "Widgets": any[],
      "Channels": any[],
      "Others": any[]
    } = {
      "APIs": [],
      "URLs": [],
      "Dashboards": [],
      "Widgets": [],
      "Channels": [],
      "Others": []
    };
    this.resourceTypes = USER_MGMT_CNST.RESOURCE_TYPES;
    data.forEach((e: any) => {
      if (this.appDetails?.['value']?.[e.resourceTypeName]) {
        let filterData = this.appDetails['value'][e.resourceTypeName].find((r: any) => r.resourceActionId === e.resourceActionId);
        e['isAssigned'] = !!filterData;
      } else {
        e['isAssigned'] = false;
      }
      if(this.resourcesIDs['resourceActionIdsToAdd']?.includes(e.resourceActionId) ) { 
        e['isAssigned'] = true;
      }
      if(this.resourcesIDs['resourceActionIdsToDelete']?.includes(e.resourceActionId) ) { 
        e['isAssigned'] = false;
      }
      resourceTypeDataMap[e.resourceTypeName as keyof typeof resourceTypeDataMap].push(e);
    });
    return resourceTypeDataMap;
  }

  assignOrUpdateResources() {

    let customerId = !isNullOrUndefined(this.customerId)? this.customerId: this.appState.getCurrentCustomerId();

    let postData: {
      "customerId": any,
      "assignResources": any[],
      "deleteResources": any[],
      "customerDetailsJson": any
    } = {
      "customerId": null,
      "assignResources": [],
      "deleteResources": [],
      "customerDetailsJson": "{}"
    }

    if (!isNullOrUndefined(customerId)) {

      postData.customerId = customerId;

      let resources = this.getformatResourceData();

      postData.assignResources = this.getAssignedResource(resources.selectedResources, resources.previouslySelectedResource);
      postData.deleteResources = this.getDeletedResource(resources.selectedResources, resources.previouslySelectedResource);
      
      if (postData.assignResources.length === 0 && postData.deleteResources.length === 0) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "No resources selected to assign / update"})
        return;
      } else {
        this.httpSrv.makePostApiCall('ASSIGN_OR_UPDATE_RESOURCES', postData, this.envService.baseUrl).subscribe({
          next: () => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Resources updated successfully' })
            this.navigateToCustomerView();
          },
          complete: () => {},
          error: () => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: "Error in assigning/updating resources"})
          }
        });
      }
    }
  }

  getAssignedResource(selectedResources: any[], previouslySelectedResource: any[]){
    let assignedResource: any[] = [];
    selectedResources.forEach((e: any)=>{
       if(previouslySelectedResource.indexOf(e) == -1){
         assignedResource.push(e);
       }
    })
    return assignedResource;
  }

  getDeletedResource(selectedResources: any[], previouslySelectedResource: any[]){
    let deletedResource: any[] = [];
    previouslySelectedResource.forEach((e: any)=>{
       if(selectedResources.indexOf(e) == -1){
         deletedResource.push(e);
       }
    });

    return deletedResource;
  }

  getformatResourceData(){
    let selectedResources: any[] = [];
    let previouslySelectedResource: any[] = [];
    this.resourceTypes = USER_MGMT_CNST.RESOURCE_TYPES;
    this.resourceTypes.forEach((type: any)=>{
      let selectedList: any[] = [];
      if(this.resourcesData && Object.keys(this.resourcesData).length !=0 && this.resourcesData[type]){
        let list = this.resourcesData[type].map((e: any) => {return {resourceActionId:e['resourceActionId'], isAssigned:e['isAssigned']}});
        let filteredList = list.filter((e: any)=> e['isAssigned'] === true);
        selectedList = filteredList.map((e: any)=> e['resourceActionId']);
      }

      let previouslySelectedList = [];
      if(this.appDetails['value'] && Object.keys(this.appDetails['value']).length !=0 && this.appDetails['value'][type]){
        previouslySelectedList = this.appDetails['value'][type].map((e: any) => e['resourceActionId']);
      }
      selectedResources = selectedResources.concat(selectedList);
      previouslySelectedResource = previouslySelectedResource.concat(previouslySelectedList);
    });

    return {selectedResources, previouslySelectedResource};
  }

  navigateToCustomerView() {
    this.router.navigate(['usermgmt', 'customer', 'addCustomer'], {
      queryParamsHandling: 'merge'
    });
  }
  
  buildCustomerInfo() {

    if (!isNullOrUndefined(this.customerDetails)) {
      return {
        ...this.customerDetails['info'],
        customerId: this.customerId,
        primaryContact: this.customerDetails['info'].primaryContact,
        secondaryContact: this.customerDetails['info']['secondaryContact']? this.customerDetails['info']['secondaryContact'] : null
      };
    }
  }

  removeEditAlsoIfReadRemoved(resourceType: string, resource:any) {
    const targetResource =this.resourcesData[resourceType]?.find((res: any) => res.resourceActionId == resource.resourceActionId);
    if (!targetResource) {
      console.error('Target resource not found for:', resource);
      return; 
  }
    const { resourceActionName, isAssigned, resourceName } = targetResource;
    
    // Check if no changes are needed
    if ((resourceActionName === 'READ' && isAssigned) || (resourceActionName === 'EDIT' && !isAssigned)) {
    return;
    }
    
    // Determine the opposite action to find ('READ' if 'EDIT' and vice versa)
    const actionToFind = resourceActionName === 'READ' ? 'EDIT' : 'READ';
    
    // Find the corresponding resource with the opposite action
    const matchingResource = this.resourcesData[resourceType].find(
    (resource: any) =>
    resource.resourceName === resourceName && resource.resourceActionName === actionToFind
    );
    
    // If a matching resource is found, update its assignment
    if (matchingResource) {
    matchingResource.isAssigned = isAssigned;
  }
}
  
}
